var _defs, _g, _path, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1511.41 604.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-28);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-20);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-9 {\n        fill: #f68e2c;\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-32);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-31);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient-25);\n      }\n\n      .cls-17 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient-24);\n      }\n\n      .cls-20 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-21 {\n        fill: url(#linear-gradient-22);\n      }\n\n      .cls-22 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-23 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-24 {\n        fill: url(#linear-gradient-27);\n      }\n\n      .cls-25 {\n        fill: url(#linear-gradient-29);\n      }\n\n      .cls-26 {\n        fill: url(#linear-gradient-30);\n      }\n\n      .cls-27 {\n        fill: url(#linear-gradient-23);\n      }\n\n      .cls-28 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-29 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-30 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-31 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-32 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-33 {\n        fill: url(#linear-gradient-26);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 448.1,
    y1: 78.44,
    x2: 331.93,
    y2: 324.47,
    gradientTransform: "translate(56.72 67.93) rotate(-2.53)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ace1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#005f92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 580.74,
    y1: 141.08,
    x2: 464.56,
    y2: 387.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 733.39,
    y1: 213.17,
    x2: 617.22,
    y2: 459.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 906.14,
    y1: 294.74,
    x2: 789.96,
    y2: 540.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1069.81,
    y1: 372.03,
    x2: 953.63,
    y2: 618.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1035.81,
    y1: 328.67,
    x2: 900.19,
    y2: 615.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 556.44,
    y1: 217.36,
    x2: 220.29,
    y2: 393.12,
    gradientTransform: "translate(109.53 122.3) rotate(-4.93)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 331.18,
    y1: 129.91,
    x2: 232.26,
    y2: 339.37,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1146.88,
    y1: 23.26,
    x2: 1013.2,
    y2: 142.87,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1146.88,
    y1: 23.26,
    x2: 1013.2,
    y2: 142.87,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1146.85,
    y1: 23.23,
    x2: 1013.17,
    y2: 142.83,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1146.88,
    y1: 23.26,
    x2: 1013.2,
    y2: 142.87,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 172.45,
    y1: 329.5,
    x2: 38.77,
    y2: 449.1,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 172.45,
    y1: 329.5,
    x2: 38.77,
    y2: 449.1,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 172.42,
    y1: 329.46,
    x2: 38.74,
    y2: 449.07,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 172.45,
    y1: 329.5,
    x2: 38.77,
    y2: 449.1,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 1246.04,
    y1: -61.54,
    x2: 1019.21,
    y2: 141.42,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1246.04,
    y1: -61.54,
    x2: 1019.21,
    y2: 141.42,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 1245.98,
    y1: -61.6,
    x2: 1019.15,
    y2: 141.36,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 1246.04,
    y1: -61.54,
    x2: 1019.21,
    y2: 141.42,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 115.44,
    y1: 253.71,
    x2: 34.93,
    y2: 325.73,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 115.44,
    y1: 253.71,
    x2: 34.93,
    y2: 325.73,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 115.42,
    y1: 253.69,
    x2: 34.92,
    y2: 325.71,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 115.44,
    y1: 253.71,
    x2: 34.93,
    y2: 325.73,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 1491.15,
    y1: 358.34,
    x2: 1332.6,
    y2: 500.21,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 1482.63,
    y1: 365.97,
    x2: 1341.91,
    y2: 491.88,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 1486.58,
    y1: 362.29,
    x2: 1337.44,
    y2: 495.73,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 1470.25,
    y1: 377.04,
    x2: 1355.35,
    y2: 479.85,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 1496.49,
    y1: 253.67,
    x2: 1232.04,
    y2: 490.28,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 1496.49,
    y1: 253.67,
    x2: 1232.04,
    y2: 490.28,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 1496.42,
    y1: 253.6,
    x2: 1231.97,
    y2: 490.21,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 1496.49,
    y1: 253.67,
    x2: 1232.04,
    y2: 490.28,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M399.62,446.45c-19.48-12.35-29.88-33.5-31.2-63.44-.14-3.21-.12-6.6,.08-10.18,3.05-35.84,9.32-63.62,18.81-83.33,2.74-2.62,6.43-4.03,11.06-4.24,6.77-.3,14.02,1.97,21.73,6.81,7.71,4.84,12.98,10.94,15.81,18.32,.79,1.76,1.23,3.7,1.33,5.83,.3,6.78-3.2,20.5-10.5,41.18-5.63,18.11-9.88,33.03-12.75,44.76-2.88,11.74-4.39,19.93-4.54,24.58,.2,4.63,.7,7.82,1.49,9.58,.74,.68,1.47,1.01,2.19,.98,3.92-.17,9.45-4.26,16.6-12.25,7.15-8,13.35-17.11,18.61-27.34,16.46-31.44,28.11-50.53,34.96-57.26,1.8,.28,2.89,.77,3.28,1.46,.02,.36-1.13,2.82-3.42,7.38-2.3,4.57-5.09,10.14-8.37,16.71-7.92,14.64-13.85,25.98-17.78,34-15.72,32.12-30.89,48.51-45.5,49.16-3.93,.17-7.89-.72-11.9-2.69Zm24.33-188.57c-14.26-7.58-21.71-18.5-22.34-32.76l-.17-3.74c.49-13.23,6.07-20.09,16.77-20.56,11.4-.5,23.48,6.11,36.23,19.82,2.66,3.82,4.11,8.04,4.31,12.67,.38,8.55-3.39,16.22-11.3,23-3.46,2.66-7.14,4.07-11.06,4.24-3.57,.16-7.72-.73-12.44-2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M594.17,448.55c-16.01-6.44-24.56-22.31-25.68-47.61-1.03-23.17,4.23-53.57,15.78-91.23,4.39-13.76,7.72-25.25,9.99-34.46,2.27-9.21,3.36-14.88,3.26-17.02l-.02-.54-1.07,.05c-3.93,.17-11.64,7.48-23.14,21.92-16.43,24.3-31.75,65.34-45.98,123.1-3.63,14.8-6.39,25.1-8.28,30.9-1.89,5.79-4.02,10.17-6.38,13.14-2.73,2.97-5.69,4.54-8.9,4.68-4.99,.22-10.09-2.06-15.3-6.82-5.22-4.78-9.26-11.38-12.13-19.82-2.07-6.34-3.36-15.39-3.88-27.15-1.01-22.81,.77-47.18,5.34-73.09,4.75-21.64,10.18-36.16,16.28-43.58,3.1-2.63,6.6-4.04,10.53-4.22,6.77-.3,13.85,2.42,21.25,8.17,6.29,5.08,9.65,12.25,10.06,21.52,.22,5-.42,10.73-1.92,17.23-.86,4.68-1.27,7.56-1.23,8.62l.02,.54c.35-.02,1.27-1.66,2.73-4.94,1.46-3.28,3.16-7.28,5.09-12.01,18.9-40.83,37.78-66.31,56.62-76.43,2.46-.82,4.76-1.28,6.9-1.38,1.78-.08,3.93,.19,6.46,.79,16.67,5.69,25.54,20.3,26.58,43.82,.36,8.2-.3,17.52-1.98,27.94-1.1,7.55-3.57,18.2-7.42,31.93-3.86,13.75-10.31,35.46-19.35,65.14-1.87,6.15-3.33,11.57-4.37,16.26-1.05,4.68-1.54,7.57-1.49,8.64l.02,.53c.37,.33,.91,.49,1.63,.46,3.21-.14,8.45-2.7,15.73-7.66,11.75-8.74,24.87-26.99,39.36-54.78,5.29-9.52,10.35-18.31,15.17-26.39,4.82-8.06,8.9-14.67,12.25-19.83,3.34-5.15,5.37-7.74,6.08-7.77,1.42-.06,2.17,.62,2.23,2.04,.14,3.21-3.44,11.05-10.74,23.51-7.6,13.91-14.53,26.89-20.78,38.96-18.45,35.1-35.51,56.92-51.21,65.48-3.85,1.95-7.02,2.99-9.5,3.1-2.5,.11-5.38-.48-8.65-1.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M741.26,491.86c-11.51-1.63-17.52-8.52-18.06-20.63-.08-1.79,.01-3.75,.28-5.9,4.01-38.4,19.37-70.68,46.07-96.86,8.32-5.73,13.32-13.62,15.02-23.7,7.97-29.63,12.12-53.04,12.43-70.19,.21-3.22,.27-6.08,.16-8.58-.2-4.63-1.03-6.92-2.45-6.86-2.14,.09-5.92,3.48-11.34,10.14-20.36,24.12-39.27,72.99-56.72,146.62-3.65,14.44-6.47,23.32-8.47,26.62-2.04,2.23-4.49,3.41-7.34,3.54-2.5,.11-5.57-.65-9.21-2.27-6.19-2.59-10.88-7.74-14.08-15.45-3.2-7.72-5.17-19.95-5.91-36.7-.22-4.99-.28-10.34-.18-16.06-.11-58.92,9.7-119.71,29.43-182.37,15.2-43.88,28.35-73.58,39.45-89.07,3.43-3.01,7.65-4.62,12.64-4.85,9.62-.43,18.76,4.53,27.44,14.86,2.63,3.1,4.07,7.14,4.29,12.13,.39,8.91-4.04,25.89-13.28,50.94-4.44,12.7-8.85,26.02-13.23,39.96-4.39,13.95-8.44,27.25-12.16,39.91-3.73,12.67-6.64,23.51-8.74,32.53-2.1,9.02-3.1,14.6-3.01,16.74l.05,1.07c.71-.03,2.7-3.51,5.97-10.44,11.79-24.09,23.64-42.65,35.57-55.68,3.78-3.38,7.98-5.17,12.62-5.38,11.4-.5,21.97,8.32,31.71,26.45,3.73,11.62,5.94,25.27,6.64,40.96,.3,6.77,.21,12.85-.27,18.23-.53,4.31-.75,7.18-.69,8.6l.05,1.07c1.78-.08,7.3-2.47,16.56-7.16,9.25-4.7,15.78-8.37,19.6-11.05,5.17-4.15,8.83-6.28,10.97-6.38,1.78-.08,2.72,.95,2.81,3.09,.11,2.5-3.56,6.41-11,11.74-7.45,5.33-16.77,10.57-27.96,15.7-6.65,3.16-10.83,5.48-12.55,6.98-1.35,1.85-2.75,6.55-4.2,14.11-7.53,31.76-19.7,63.37-36.52,94.83-9.7,15.07-19.72,26.4-30.1,34.01-5.58,3.1-11.04,4.77-16.38,5.01-2.14,.09-4.11,0-5.9-.27Zm5.69-40.97c3.62-6.95,6.23-12.42,7.84-16.42,.99-1.83,2.51-5.65,4.58-11.45,2.06-5.81,4.2-11.97,6.41-18.5,2.2-6.53,4.18-12.32,5.93-17.41,1.73-5.07,2.6-7.79,2.59-8.15-.03-.71-.41-1.05-1.12-1.02-1.43,.06-4.83,3.88-10.21,11.43-5.38,7.56-10.02,15.71-13.92,24.46-7.62,21.41-11.25,36.39-10.87,44.94,.11,2.49,.52,3.73,1.24,3.7,1.07-.05,3.58-3.91,7.52-11.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M973.74,431.21c-12.36-4.81-19.17-21.65-20.45-50.52-.46-10.33-.05-21.24,1.23-32.73,1.1-7.19,1.63-11.67,1.55-13.46l-.05-1.07-13.1,18.79c-10.36,16.18-18.59,27.88-24.7,35.11-6.11,7.23-11.1,11.47-14.97,12.72l-2.14,.09c-6.07,.27-12.84-3.54-20.33-11.42-5.65-6.53-8.82-17.82-9.53-33.86l-.28-6.42c.49-29.3,9.88-55.25,28.16-77.85,5.43-6.31,10.4-10.99,14.91-14.05,4.88-2.71,9.99-4.19,15.34-4.43,12.47-.55,24.66,4.45,36.56,14.99l6.7,6.13,3.36-8.72c2.25-5.46,4.42-8.94,6.5-10.47,2.09-1.16,4.56-1.81,7.41-1.94,4.63-.2,9.32,.84,14.07,3.13,9.84,4.57,15.18,12.19,16.01,22.86l.07,1.6c.22,5-1.36,13.81-4.72,26.46-3.37,12.65-10.4,35.47-21.08,68.43-5.31,17.38-8.34,29.47-9.11,36.3-.23,2.86-.31,5.01-.25,6.44,.11,2.49,1.22,3.34,3.33,2.53,7.12-.32,16.67-6.46,28.65-18.41,11.97-11.96,21.93-25.08,29.86-39.36,10.19-19.74,17.46-33,21.81-39.8,4.34-6.8,7.22-10.23,8.65-10.29,.71-.03,1.48,1.19,2.3,3.65l.07,1.6c.08,1.79-1.53,5.96-4.8,12.53-3.28,6.57-10.4,19.21-21.36,37.91-17.62,29.71-36.68,50.91-57.18,63.6-2.8,1.55-5.97,2.41-9.53,2.56-4.64,.21-8.96-.68-12.98-2.64Zm-24.24-111.96l-3.49-6.27c-2.69-4.17-4.39-6.23-5.1-6.2-1.07,.05-3.29,2.47-6.64,7.26-3.36,4.79-6.95,10.49-10.76,17.08-3.82,6.6-6.85,12.81-9.09,18.62-5.86,12.76-8.75,20.21-8.65,22.35,.03,.72,.22,1.06,.58,1.05,1.07-.05,3.64-2.48,7.71-7.31,6.1-7.41,13.53-16.85,22.32-28.31l13.12-18.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1190.5,438.76c-14.86-4.7-25.42-17.45-31.69-38.24-2.71-12.74-4.42-27.3-5.15-43.7-.38-8.55-.35-15.87,.1-21.97,.3-1.08,.45-1.98,.42-2.7-.02-.35-.21-.53-.56-.51s-1.35,1.76-2.98,5.22c-1.64,3.47-4.25,9.03-7.83,16.69-13.71,29.18-24.47,48.22-32.29,57.14-3.41,3.72-7.25,5.68-11.53,5.87-5.35,.24-10.63-2.03-15.84-6.8-5.22-4.78-9.27-11.56-12.15-20.36-3.42-12.7-5.44-26.18-6.08-40.44-.27-6.06-.16-11.59,.34-16.62,4.57-41.99,20.04-71.6,46.42-88.84,4.84-3.43,11.72-5.34,20.64-5.74,9.62-.43,17.55,1.37,23.81,5.37l12.58,5.87,1.32-6.49c1.17-5.76,3.51-17.47,7.02-35.13,8.75-44.32,16.02-77.76,21.81-100.34,5.78-22.57,10.74-35.74,14.86-39.5,3.43-3.01,7.47-4.62,12.11-4.82,7.84-.35,15.8,2.07,23.89,7.25,8.08,5.18,12.28,11.16,12.58,17.92,.17,3.93-.86,10.94-3.09,21.03-2.23,10.1-7.35,29.79-15.33,59.07-20.47,78.05-35.55,140.86-45.23,188.43-4.7,23.07-6.82,39.58-6.38,49.57,.35,7.84,.73,12.56,1.16,14.15,.42,1.59,1.53,2.34,3.31,2.26l1.07-.05c6.06-.27,14.22-5.64,24.47-16.08,7.9-7.14,21.23-28.61,40-64.45,6.93-12.8,11.73-21.41,14.39-25.82,2.66-4.4,4.53-6.63,5.6-6.68,.71-.03,1.26,.3,1.65,1,.37,.34,.58,.87,.61,1.58,.06,1.43-.96,4.51-3.07,9.24-2.12,4.74-5.98,12.23-11.59,22.48-29.3,56.29-50.78,87.24-64.46,92.85-3.47,2.3-6.27,3.49-8.41,3.59-1.79,.08-3.95-.36-6.49-1.32Zm-81.54-51.03c17.85-24.36,34.28-56.51,49.3-96.47,2.22-6.17,3.27-10.86,3.13-14.07-.14-3.21-1.47-4.76-3.96-4.65-5.35,.24-14.88,10.84-28.59,31.8-4.65,8.07-8.92,16.29-12.84,24.67-11.79,32.31-17.45,53.63-16.99,63.97,.09,2.14,.49,3.19,1.21,3.16,1.07-.05,3.97-2.86,8.73-8.42Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1245.03,378.55c28.67-111.6,127.41-323.16,209-309.85,81.59,13.32,68.26,130.47,9.39,159.76-58.87,29.29-121.14,34.22-306.52-52.45-125.39-58.63-224.46-39.54-267.91-20.44-47.26,20.77-26.51,1.08-26.51,1.08,120.76-79.4,284.78-12.61,447.24,50.23s201.34-104.4,126.72-117.29-151.92,222.34-151.92,222.34c0,0-33.74,133.1-87.54,128.16,0,0,48.3-34.14,48.05-61.53"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M60.67,386.67s-.39,194.51,334.22,112.31c334.61-82.2,315.29,75.13,315.29,75.13,0,0-2.65,10.95-36.58-35.12-43.59-59.19-172.01-51.68-272.17-16.37-100.15,35.31-366.18,35.25-340.76-135.95Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M876.37,483.1h20.15c20.54,0,25.23,11.39,20.94,31.52l-7.92,37.17c-3.63,16.94-8.36,26.79-27.99,26.79h-25.45l20.27-95.48Zm.66,81.3h3.58c6.46,0,8.86-3.87,10.37-10.93l9.47-44.75c1.51-7.03,1.17-11.36-5.76-11.36h-3.34l-14.33,67.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M930.84,503.22h18l-16.03,75.36h-18l16.03-75.36Zm5.19-24.32h18l-3.54,16.63h-18l3.53-16.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M990.41,571.82c-3.91,18.52-5.7,32.34-28.29,32.34-19.54,0-22.2-10.37-20.24-20.26l.14-.71h18.09l-.14,.86c-.43,2.58-.51,6.03,3.72,6.03,4.99,0,5.94-5.5,7.69-13.49l1.46-6.76c-2.88,4.5-7.43,6.78-12.82,6.78-13.26,0-14.45-11.8-11.87-23.81l5.83-27.11c2.2-10.2,6.33-23.61,20.3-23.61,7.04,0,10.32,3.17,11.61,6.98,.57-2.2,1.63-4.7,2.15-5.84h17.18c-1.35,5.53-2.78,11.94-4.65,20.83l-10.19,47.78Zm-18.28-46.74l-5.77,27.21c-1.23,5.82-.46,9.01,3.55,9.01,4.28,0,5.81-3.62,7.41-11.11l5.22-24.66c.89-4.52,.89-8.64-3.59-8.64-4.01,0-5.67,3.06-6.81,8.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1016.4,503.22h18l-16.03,75.36h-18l16.03-75.36Zm5.19-24.32h18l-3.54,16.63h-18l3.53-16.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1050.21,483.1h22.13c15.34,0,21.77,8.1,18.66,24.25l-.9,4.64c-2.11,10.54-6.99,14.87-12.91,16.55,6.15,2.95,9.34,9.16,7.22,19.42l-1.39,6.88c-3.34,16.88-9.55,23.74-28.19,23.74h-24.89l20.27-95.48Zm.32,81.4h4.47c6.46,0,8.07-3.08,9.58-10.57l1.84-9.29c1.28-6.58,.65-9.73-6.61-9.73h-2.96l-6.32,29.58Zm13.22-43.47c5.36,0,7.21-2,8.72-9.53l1.12-5.48c1.09-5.75,.49-8.71-6.16-8.71h-2.61l-4.99,23.72h3.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1144.51,528.32l-5.77,27.46c-3.44,16.44-10.34,24-26.55,24s-22.95-9.09-19.51-25.5l6.2-29.18c3.41-16.22,11.54-23.02,26.11-23.02,15.31,0,23.12,9.02,19.52,26.25Zm-27.34-3.98l-7.02,33.2c-1.04,4.7-.1,7.86,3.91,7.86s5.26-3.36,6.25-8.04l7.02-33.16c.9-4.26,.75-7.89-3.83-7.89-4.15,0-5.34,3.5-6.33,8.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1172.26,503.22c.55,6.19,1.55,19.07,1.68,23.4h.5c2.58-6.05,6.72-16.02,10.05-23.4h19.42l-21.44,35.94,6.45,39.42h-18.36c-.64-7.48-1.71-20.52-1.88-24.81h-.45c-2.21,5.45-7.39,16.39-11.7,24.81h-19.03l22.54-39.03-6.14-36.32h18.35Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M381.78,345.99c-2.5,.11-6.4,.64-11.71,1.59-3.91,.53-7.82,.88-11.74,1.06-14.62,.65-30.61-1.68-47.99-6.98-7.95-2.14-13.48-3.96-16.58-5.43-3.1-1.47-4.68-2.92-4.75-4.34-.03-.71-1.05-3.52-3.05-8.44-2.01-4.91-4.58-10.69-7.73-17.34-18.56-39.89-28.33-71.24-29.34-94.06-.81-18.18,1.47-27.39,6.81-27.62,11.76-.52,31.65-11.22,59.65-32.1,9.55-8.95,18.25-17.86,26.13-26.73-3.36-2.73-6.8-5.04-10.22-6.99-12.87,18.22-30.31,33.39-52.35,45.51-8.72,4.67-15.02,7.63-18.89,8.87l-5.83,1.33,2.37-7.07c8.91-21.8,22.69-41.48,41.28-59.07-1.22-.1-1.9-.11-1.9-.11,0,0-79.08,7.83-110.66,65.43-.31,4.33-.27,11.13,.15,20.47,1.2,27.09,9.04,54.96,23.52,83.6,2.79,6.66,5.09,12.19,6.89,16.57,1.8,4.39,2.72,6.94,2.75,7.65-1.43,.06-5.94-.98-13.53-3.15-15.19-4.32-30.46-6.15-45.78-5.47-12.83,.57-24.87,2.89-36.12,6.96-20.72,8.07-36.46,19.56-47.22,34.5-10.77,14.94-15.75,31.5-14.94,49.68,.47,10.69,3.1,21.65,7.88,32.87,20.67,39.44,54.41,63.48,101.23,72.12,5.75,.82,12.54,1.05,20.39,.7,16.04-.71,30.4-2.95,43.09-6.73,36.16-14.11,57.73-39.17,64.71-75.19,1.54-5.43,2.14-12.06,1.8-19.9-.16-3.56-.52-7.65-1.08-12.27-1.25-12.08-2.32-20.07-3.2-23.96l-1.28-4.76,17.37,5.12c17.36,4.95,33.34,7.09,47.96,6.45,3.92-.17,7.65-.51,11.2-1.03,10.68-.82,15.92-3.38,15.73-7.66,.94-2.9-.72-4.25-5-4.06Zm-155.49,93.67c-12.31,12.33-26.61,20.1-42.9,23.33-5.66,1.32-10.8,2.09-15.43,2.29-5.71,.25-11.63-.38-17.76-1.89-20.55-4.45-37.69-14.32-51.4-29.6-13.72-15.28-20.97-32.02-21.77-50.2-.22-4.99,.1-9.82,.97-14.51,4.69-23.06,19.08-41.02,43.15-53.87,13.26-7.02,27.02-10.84,41.28-11.47,4.28-.19,8.57-.02,12.88,.5,22.25,2.59,39.04,6.67,50.36,12.23,6.12,9.37,12.51,24.45,19.14,45.22,1.74,7.07,2.76,13.99,3.06,20.76,.96,21.75-6.23,40.81-21.57,57.2Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M334.03,94.45c-33.39,2.16-118.56,12.44-145.86,61.33,0,0-26.15-34.47-3.89-57.98,21.62-22.83,126.08-58.71,183.69-17.05,4.27,3.09,5.4,8.9,2.1,12.93-2.4,2.93-6.77,4.97-14.7,2.97-6.96-1.75-14.12-2.67-21.34-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M339.57,62.68c-24.47-5.61-87.81-16.9-117.01,8.38,0,0-12.1-27.3,8.53-37.55,20.03-9.95,102.26-10.86,135.61,27.58,2.47,2.85,2.15,6.77-1.01,8.63-2.3,1.35-5.84,1.74-11.17-1.19-4.67-2.56-9.65-4.64-14.94-5.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M172.65,211.56c.81,1.28,2.77,.67,2.64-.85l-2.22-26.39s1.09-26.6-44.25-23.03c-45.34,3.57-79.83,75.07-128.83,34.3,0,0,.49,8.58,3.35,18.54,5.73,19.97,26.98,31.15,46.68,24.58,13.61-4.54,31.18-12.76,44.18-27.14,22.13-24.48,64.64-21.94,78.44-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M307.72,104.7s33.29-4.39,49.58,1.51c2.59,.94,3.3,4.28,1.39,6.26l-7.69,8c-1.36,1.42-3.56,1.59-5.12,.38-5.62-4.34-19.74-13.85-38.17-16.15Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "1085.01 91.35 1082.98 101.34 1080.95 91.35 1080.95 67.26 1082.98 59.53 1085.01 67.26 1085.01 91.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1072.07 82.46 1062.08 80.43 1072.07 78.4 1096.16 78.4 1103.89 80.43 1096.16 82.46 1072.07 82.46"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "1078.26 87.31 1071.88 91.54 1076.11 85.15 1088.9 72.35 1094.09 69.33 1091.06 74.51 1078.26 87.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "1076.11 75.71 1071.88 69.33 1078.26 73.55 1091.06 86.35 1094.09 91.54 1088.9 88.51 1076.11 75.71"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "110.59 397.58 108.56 407.57 106.52 397.58 106.52 373.49 108.56 365.76 110.59 373.49 110.59 397.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "97.64 388.7 87.65 386.67 97.64 384.63 121.73 384.63 129.46 386.67 121.73 388.7 97.64 388.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "103.84 393.54 97.45 397.77 101.68 391.38 114.47 378.59 119.66 375.56 116.63 380.75 103.84 393.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "101.68 381.95 97.45 375.56 103.84 379.79 116.63 392.58 119.66 397.77 114.47 394.74 101.68 381.95"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1141.07 53.99 1137.62 70.94 1134.17 53.99 1134.17 13.12 1137.62 0 1141.07 13.12 1141.07 53.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1119.1 38.92 1102.15 35.47 1119.1 32.02 1159.97 32.02 1173.09 35.47 1159.97 38.92 1119.1 38.92"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "1129.61 47.14 1118.77 54.31 1125.95 43.48 1147.66 21.77 1156.46 16.63 1151.32 25.43 1129.61 47.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1125.95 27.47 1118.77 16.63 1129.61 23.8 1151.32 45.51 1156.46 54.31 1147.66 49.18 1125.95 27.47"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "78.18 294.71 76.96 300.72 75.73 294.71 75.73 280.2 76.96 275.55 78.18 280.2 78.18 294.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "70.38 289.36 64.37 288.13 70.38 286.91 84.89 286.91 89.55 288.13 84.89 289.36 70.38 289.36"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "74.12 292.28 70.27 294.82 72.82 290.98 80.52 283.27 83.64 281.45 81.82 284.57 74.12 292.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "72.82 285.29 70.27 281.45 74.12 283.99 81.82 291.7 83.64 294.82 80.52 293 72.82 285.29"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "1417.51 439.1 1415.37 450.95 1413.23 439.1 1413.23 410.53 1415.37 401.36 1417.51 410.53 1417.51 439.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "1403.88 428.56 1393.36 426.15 1403.88 423.74 1429.23 423.74 1437.37 426.15 1429.23 428.56 1403.88 428.56"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "1410.4 434.31 1403.68 439.32 1408.13 431.75 1421.6 416.57 1427.06 412.98 1423.87 419.13 1410.4 434.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1408.13 420.56 1403.68 412.98 1410.4 418 1423.87 433.17 1427.06 439.32 1421.6 435.73 1408.13 420.56"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "1374.1 388.35 1370.08 408.12 1366.06 388.35 1366.06 340.7 1370.08 325.41 1374.1 340.7 1374.1 388.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "1348.49 370.78 1328.73 366.76 1348.49 362.74 1396.14 362.74 1411.44 366.76 1396.14 370.78 1348.49 370.78"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "1360.75 380.37 1348.12 388.73 1356.48 376.1 1381.79 350.78 1392.05 344.8 1386.06 355.06 1360.75 380.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1356.48 357.43 1348.12 344.8 1360.75 353.16 1386.06 378.47 1392.05 388.73 1381.79 382.74 1356.48 357.43"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.7dd478b0cd830e8b368101c2e74f52e7.svg";
export { ForwardRef as ReactComponent };